import { render, staticRenderFns } from "./ReposListPublic.vue?vue&type=template&id=68bdc894&scoped=true&"
import script from "./ReposListPublic.vue?vue&type=script&lang=js&"
export * from "./ReposListPublic.vue?vue&type=script&lang=js&"
import style0 from "./ReposListPublic.vue?vue&type=style&index=0&id=68bdc894&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bdc894",
  null
  
)

export default component.exports